import {
	CHANGE_ARTICLES_LIST_SETTINGS, LOGOUT, PAGE_SHIFT_ARTICLES, RECEIVE_ARTICLE_ATTACHMENT, RECEIVE_ARTICLES_MESSAGE,
	RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE, RECEIVE_DELETE_ARTICLE,
	RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE,
	RECEIVE_FAILED_RESPONSE_GET_ARTICLES,
	RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE, RECEIVE_FAILURE_ARTICLE_ATTACHMENT, RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS,
	RECEIVE_GET_ARTICLES, RECEIVE_PATCH_ARTICLE, REQUEST_ARTICLE_ATTACHMENT, REQUEST_ARTICLES_MESSAGE,
	REQUEST_DELETE_ARTICLE,
	REQUEST_GET_ARTICLES, REQUEST_PATCH_ARTICLE
} from "../actions/index";
import _ from 'lodash';

const defaultState = {
	articles: [],
	selectedView: 20,
	selectedAction: '',
	selectedStatus: '',
	selectedArticles: {},
	selectedAllArticles: false,
	pageArticles: [],
	page: 1,
	featuredArticles: [],
	totalBoxes: 1,
	fetching: false,
	suggestions: [],
	selectedSuggestions: [],
	value: '',
	patching: false,
	deleteModal: false,
	deleting: false,
	failedDeleteMsg: '',
	infoMessage: '',
	fetchingInfoMessage: false,
	badRequestInfoMessage: '',
	documentToDownload: {},
	fetchingDocument: false,
	failedToGetDocumentMsg: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: true,
				infoMessage: ''
			};
		case RECEIVE_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: false,
				infoMessage: action.payload.body
			};
		case RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: false,
				badRequestInfoMessage: action.payload
			};
		case REQUEST_DELETE_ARTICLE:
			return {
				...state,
				deleting: true
			};
		case RECEIVE_DELETE_ARTICLE:
			let newFeaturedArticles = _.filter(state.featuredArticles, (article) => {return article.id !== action.payload.id});
			selectedArticles = _.pickBy(state.selectedArticles, (article) => {return article.id !== action.payload.id});
			return {
				...state,
				deleting: false,
				articles: _.filter(state.articles, (article) => {return article.id !== action.payload.id}),
				featuredArticles: newFeaturedArticles,
				selectedArticles: {},
				deleteModal : false,
			};
		case RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE:
			return {
				...state,
				deleting: false,
				failedDeleteMsg: action.payload
			};
		case RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS:

			return {
				...state,
				suggestions: action.payload.data
			};
		case REQUEST_PATCH_ARTICLE:
			return {
				...state,
				patching: true
			};
		case RECEIVE_PATCH_ARTICLE:
			const itemBeforeUpdate = state.articles.find(article => article.id === action.payload.id);

			let newArticles = state.articles.map(article => {
				if(article.id === itemBeforeUpdate.id){
					return action.payload;
				}

				if(
					article.id !== itemBeforeUpdate.id
					&& article.weight === action.payload.weight
				){
					return {...article, weight: itemBeforeUpdate.weight}
				}

				return article
			});

			return {
				...state,
				articles: newArticles,
				patching: false
			};
		case RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE:
			return {
				...state,
				patching: false
			};
		case REQUEST_GET_ARTICLES:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_ARTICLES:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = state.page;
			if(state.page > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				fetching: false,
				articles: action.payload.data,
				totalBoxes: totalDisplayBoxes,
				totalRecords: action.payload.totalRecords,
				page: currentPage
			};
		case RECEIVE_FAILED_RESPONSE_GET_ARTICLES:
			return {
				...state,
				fetching: false
			};
		case CHANGE_ARTICLES_LIST_SETTINGS:
			let page = action.payload.key === 'page' ? action.payload.value : state.page;
			let selectedView = action.payload.key === 'selectedView' ? parseInt(action.payload.value) : parseInt(state.selectedView);
			let selectedStatus = action.payload.key === 'selectedStatus' ? action.payload.value : state.selectedStatus;
			let selectedAction = action.payload.key === 'selectedAction' ? action.payload.value : state.selectedAction;
			let selectedSuggestions = action.payload.key === 'selectedSuggestions' ? action.payload.value : state.selectedSuggestions;

			let selectedArticles ;

			return {
				...state,
				[action.payload.key]: action.payload.value,
				page: page,
				// selectedArticles: action.payload.key = 'selectedArticles?' selectedArticles,
				// selectedAllArticles: selectedAllArticles,
				selectedStatus: action.payload.key === 'selectedSuggestions' ? '' : (action.payload.key === 'selectedStatus' ? action.payload.value : state.selectedStatus)
			};
		case PAGE_SHIFT_ARTICLES:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					selectedArticles: {},
					selectedAllArticles: false,
					page: state.page + 1
				};
			else return {
					...state,
					selectedArticles: {},
					selectedAllArticles: false
			};
		case REQUEST_ARTICLE_ATTACHMENT:
			return {
				...state,
				fetchingDocument :true
			};
		case RECEIVE_ARTICLE_ATTACHMENT:
			return {
				...state,
				fetchingDocument: false,
				documentToDownload: action.payload,
				failedToGetDocumentMsg:''
			};
		case RECEIVE_FAILURE_ARTICLE_ATTACHMENT:
			return {
				...state,
				fetchingDocument: false,
				failedToGetDocumentMsg: action.payload
			};
		case LOGOUT:
			return {
				...defaultState
			};
		default:
			return state
	}
}